import React, { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/Custom.css';

const CustomInput = ({ label, placeholder, value, onChange, type, className, name,star, ...rest }) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputType = type === "password" && showPassword ? "text" : type;
  const isInvalid = className?.includes('is-invalid');

  return (
    <div className="position-relative">
      <div className="text-start">
        <label 
          htmlFor={name} 
          className="form-label fw-bold" 
          style={{ fontSize: '12px', lineHeight: '14.52px' }}
        >
          {label} <span style={{color:'red'}}> {star}</span>
        </label>
        <div style={{ position: 'relative' }}>
          <input
            type={inputType}
            id={name}
            name={name}
            className={`form-control custom-input ${className}`}
            style={{ 
              borderWidth: '1.5px', 
              borderRadius: '12px', 
              paddingRight: type === 'password' ? (isInvalid ? '60px' : '40px') : '12px' 
            }}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            {...rest}
          />
          {type === "password" && (
            <span
              onClick={() => setShowPassword((prev) => !prev)}
              style={{
                position: "absolute",
                right: isInvalid ? '35px' : '10px',
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
              }}
            >
              {!showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomInput;
